import { render, staticRenderFns } from "./MastheadItem.vue?vue&type=template&id=f4984182&"
import script from "./MastheadItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./MastheadItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports